




































import Vue from 'vue';

export default Vue.extend({
  props: {
    icon: Array,
    title: String,
    url: String,
    noFlexWrap: Boolean,
  },
  methods: {
    goToRoute() {
      if (!this.url) {
        return;
      }
      this.$router.push(this.url);
    },
  },
});
